"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Headline = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Headline = function Headline(_ref) {
  var style = _ref.style,
      text = _ref.text;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.StyledHeadline, {
    bold: style === 'bold'
  }, text));
};

exports.Headline = Headline;